module.exports = __webpack_public_path__ + "static/media/van.b4ed0037.svg";